// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"602b88d6","453":"49794aae","455":"ad4b2229","977":"9a8f881f"}[chunkId] + ".chunk.js";
};